import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const Breadcrumb = ({ subject }) => {
  return (
    <ul className="breadcrumb">
      <li className="breadcrumb__item">
        <a href="/">CGTrader</a>
      </li>
      <li className="breadcrumb__item">
        <a href="/profile/dashboard">Profile</a>
      </li>
      <li className="breadcrumb__item">
        <Link to="/profile/inbox/">My Conversations</Link>
      </li>
      <li className="breadcrumb__item is-active">
        {subject}
      </li>
    </ul>
  )
}

Breadcrumb.propTypes = {
  subject: PropTypes.string.isRequired,
}

export default Breadcrumb
